import React, { useEffect, useState } from 'react';
import { Box, Button, Typography } from '@material-ui/core';
import { useDispatch } from 'react-redux';
import { useSelector } from 'react-redux';
import {
  getAkadmySchoolAnalytics,
  getAllAkademySchools,
} from '../AkademySlice';
import { exportJsonToTxt, triggerDownload } from '../../../utils/helpers';
import BuzzAutoCompleteSingleSelectInput from '../../../components/BuzzAutoCompleteInput/BuzzAutoCompleteSingleSelectInput';
import BuzzInput from '../../../components/BuzzInput/BuzzInput';
import moment from 'moment';
import useToast from '../../../hooks/useToast';

function AkademyAnalytics() {
  const dispatch = useDispatch();
  const { SuccessToast, ErrorToast } = useToast();

  const { schoolList, school } = useSelector(({ akademyReducer }) => {
    return {
      school: akademyReducer.school,
      schoolList: akademyReducer.schools,
    };
  });

  useEffect(() => {
    dispatch(getAllAkademySchools());
  }, []);

  const onChangeSchool = (id) => {
    if (!id) return;
    setSchoolId(id);
  };
  const [schoolId, setSchoolId] = useState(null);
  const [startDate, setStartDate] = useState(
    moment().subtract(1, 'years').format('YYYY-MM-DD')
  );
  const [endDate, setEndDate] = useState(moment().format('YYYY-MM-DD'));

  const downloadReport = () => {
    dispatch(getAkadmySchoolAnalytics({ schoolId, startDate, endDate }))
      .unwrap()
      .then((res) => {
        console.log(res);
        const { data } = res;

        const { link } = exportJsonToTxt(data);
        triggerDownload(link, `school_analytics_report_${schoolId}.txt`);
      })
      .catch((err) => {
        ErrorToast(err.message);
      });
  };

  return (
    <Box style={{ maxWidth: '700px' }}>
      <Box
        style={{
          display: 'flex',
          justifyContent: 'space-between',
          alignItems: 'center',
        }}>
        <Typography variant="h6">School Analytics</Typography>
      </Box>

      <Box py={2} display={'flex'} flexDirection={'column'} gridGap={'20px'}>
        <Box style={{ minWidth: '300px' }}>
          <Typography color="textSecondary" style={{ fontSize: '0.85rem' }}>
            Select a school
          </Typography>
          <BuzzAutoCompleteSingleSelectInput
            options={schoolList.map(({ _id, name }) => ({
              label: name,
              value: _id,
            }))}
            value={schoolId}
            onChange={(value) => onChangeSchool(value)}
          />
        </Box>
        <Box display={'flex'} gridGap={'20px'}>
          <Box width={'100%'}>
            <Typography color="textSecondary" style={{ fontSize: '0.85rem' }}>
              Start date
            </Typography>
            <BuzzInput
              type="date"
              value={startDate}
              onChange={(e) => setStartDate(e.target.value)}
            />
          </Box>
          <Box width={'100%'}>
            <Typography color="textSecondary" style={{ fontSize: '0.85rem' }}>
              End date
            </Typography>
            <BuzzInput
              type="date"
              value={endDate}
              onChange={(e) => setEndDate(e.target.value)}
            />
          </Box>
        </Box>
        <Button
          variant="contained"
          color="primary"
          onClick={downloadReport}
          disabled={!schoolId || !startDate || !endDate || school.isLoading}>
          Download Report
        </Button>
      </Box>
    </Box>
  );
}

export default AkademyAnalytics;
